module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_HR-37b34f02c21512e284fc82ea67bb9836.svg";